import { render, staticRenderFns } from "./PieSliceIcon.vue?vue&type=template&id=4cb09d44&"
import script from "./PieSliceIcon.vue?vue&type=script&lang=ts&"
export * from "./PieSliceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4cb09d44', component.options)
    } else {
      api.reload('4cb09d44', component.options)
    }
    module.hot.accept("./PieSliceIcon.vue?vue&type=template&id=4cb09d44&", function () {
      api.rerender('4cb09d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/PieSliceIcon.vue"
export default component.exports